import { IState } from '../../store';

export const getOfferId = (state: IState): number => {
  return state.offerData.offer.id;
};
